import "bootstrap/dist/css/bootstrap.min.css";
import polo from '../assets/Inicio/Clientes/TECHNOPOLO.jpg';
import blipack from '../assets/Inicio/Clientes/BLIPACK-300x60.png'
import aerosoles from '../assets/Inicio/Clientes/logo-AEROSOLES.png'
import distrito from '../assets/Inicio/Clientes/Distrito T.jpeg'
import consorcio2 from '../assets/Inicio/Clientes/admin consorcio 2.jpeg'

const ImageCarousel = () => {
  const images = [
    { id: 4, src: {polo}, alt: "Imagen 4" },
    { id: 2, src: {blipack}, alt: "Imagen 2" },
    { id: 1, src: {aerosoles}, alt: "Imagen 1" },
    { id: 5, src: {distrito}, alt:"Imagen 5" },
    { id: 3, src: {consorcio2}, alt:"Imagen 3" },
  ];
  
  return (
    
      <div className="slider-c">
        <div className="slide-track">
            <div className="slide-c">
                <img alt="" className="img-c" src={polo}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={blipack}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={aerosoles}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={distrito}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={consorcio2}/>
            </div>



            <div className="slide-c">
                <img alt="" className="img-c" src={polo}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={blipack}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={aerosoles}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={distrito}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={consorcio2}/>
            </div>

        </div>
      </div>
      
  );
}

export default ImageCarousel;